import React from "react";
import { eshopPageData } from "../../data/data";
import EshopProductDetailPage from "./EshopProductDetail";
import EshopProductCategoryPage from "./EshopProductCategoryPage";
import { useLocation } from "react-router-dom";
import { EshopInterface, Product, ProductCategory } from "../../types/Generic";

const findCategoryOrProduct = (
  eshopData: EshopInterface,
  targetPath: string
): { category?: ProductCategory; product?: Product } | null => {
  const search = (
    categories: ProductCategory[]
  ): { category?: ProductCategory; product?: Product } | null => {
    for (const category of categories) {
      if (category.path === targetPath) {
        return { category };
      }

      const productSlugMatch = targetPath.match(/^(.+?)\/p=(.+)$/);
      if (productSlugMatch) {
        const categoryPath = productSlugMatch[1];
        const productSlug = productSlugMatch[2];

        if (category.path === categoryPath) {
          const foundProduct = category.products?.find(
            (product) =>
              product.title.toLowerCase().replace(/\s+/g, "-") === productSlug
          );

          if (foundProduct) {
            return { category, product: foundProduct };
          }
        }
      }

      if (category.subCategories) {
        const result = search(category.subCategories);
        if (result) return result;
      }
    }

    return null;
  };

  return search(eshopData.sections) || null;
};

const EshopProduct = () => {
  const location = useLocation();
  const pathSegments = location.pathname
    .replace(/^\/el-parduotuve\//, "")
    .split("/");

  if (pathSegments.length === 0 || !pathSegments[0]) {
    return <></>;
  }

  const product = findCategoryOrProduct(eshopPageData, location.pathname);

  if (!product) {
    return <></>;
  }

  return product?.category?.type === "plain" || product.product ? (
    <EshopProductDetailPage productCategory={product.category!} />
  ) : (
    <EshopProductCategoryPage productCategory={product.category!} />
  );
};
export default EshopProduct;
